/**
 * Перемикач вигляду «Воронка | Список» (KAN-01; components.md, розд. 6). Окремо від текстів дошки
 * (`board.ts`): перемикач — у першому екрані списку, дошка — лінивий чанк.
 */
export const viewSwitch = {
  group: 'Вигляд',
  board: 'Воронка',
  list: 'Список',
};
